import { render, staticRenderFns } from "./Vswipe.vue?vue&type=template&id=0db635fa&scoped=true"
import script from "./Vswipe.vue?vue&type=script&lang=js"
export * from "./Vswipe.vue?vue&type=script&lang=js"
import style0 from "./Vswipe.vue?vue&type=style&index=0&id=0db635fa&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db635fa",
  null
  
)

export default component.exports